import { apiClient } from './client';

export interface OpenGraphData {
  title: string;
  description: string;
  image: string;
  url: string;
}

export type PreviewType = 'users' | 'chars' | 'scenarios';

export const preview = {
  async get(type: PreviewType, lookupId: string): Promise<OpenGraphData> {
    try {
      let endpoint: string;
      
      switch (type) {
        case 'users':
          endpoint = `/preview/users/${lookupId}/`;
          break;
        case 'chars':
          endpoint = `/preview/characters/${lookupId}/`;
          break;
        case 'scenarios':
          endpoint = `/preview/scenario-definitions/${lookupId}/`;
          break;
        default:
          throw new Error(`Invalid preview type: ${type}`);
      }
      
      const response = await apiClient.get(endpoint);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch ${type} preview data:`, error);
      throw error;
    }
  }
};
